import { render } from "./DownloadView.vue?vue&type=template&id=cc666c4a&ts=true"
import script from "./DownloadView.vue?vue&type=script&lang=ts"
export * from "./DownloadView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paul/Documents/JetBrains/PhpstormProjects/AzuriomInstaller/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__